import { render, staticRenderFns } from "./compClubAT.vue?vue&type=template&id=22c2419c&"
import script from "./compClubAT.vue?vue&type=script&lang=js&"
export * from "./compClubAT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports